import { createContext, useContext } from 'react';
const FiltersBarLayoutManagerContext = /*#__PURE__*/createContext({
  isLayoutManager: false
});
export const FiltersBarLayoutManagerProvider = FiltersBarLayoutManagerContext.Provider;
export const useFiltersBarLayoutManagerContext = () => {
  return useContext(FiltersBarLayoutManagerContext);
};
export default FiltersBarLayoutManagerContext;